import {
  MAX_FULL_NAME_LENGTH,
  MAX_NAME_LENGTH,
  MAX_PASSWORD_LENGTH,
  MIN_AGE,
  MIN_PASSWORD_LENGTH,
} from '@/constants/Common'
import { LocaleConstant } from '../en/constant'

const constants: LocaleConstant = {
  emailInvalid: '无效的邮件地址。',
  emailRequired: '需要电子邮件。',
  passRequired: '需要密码。',
  passNoWhiteSpace: '不允许有空格。',
  passMinLength: `密码长度至少为${MIN_PASSWORD_LENGTH}个字符。`,
  passMaxLength: `密码长度不能超过${MAX_PASSWORD_LENGTH}个字符。`,
  passLettersNumbers: '密码必须包含字母和数字',
  passOneNumbers: '密码必须包含至少一个数字',
  passStrength: `密码至少需要${MIN_PASSWORD_LENGTH}个字符，包含大写或小写字母和数字的组合。`,
  passMatch: '请输入匹配的密码。',
  fullNameRequired: '需要全名。',
  fullNameNoSpecial: '不允许使用数字或特殊字符。',
  fullNameNoWhitespace: '仅不允许使用空格。',
  fullNameMaxLength: `只有${MAX_FULL_NAME_LENGTH}字符是允许的`,
  nameMaxLength: `只有${MAX_NAME_LENGTH}字符是允许的`,
  typeDate: '日期格式应为 月/日/年。',
  birthDateRequired: '需要出生日期。',
  birthDateMin: `最小年龄为${MIN_AGE}岁。`,
  emailConfirm: '电子邮件内容不符。',
  locationRequired: '位置为必填项',
  locationNeedsCity: '请选择一个城市或城镇。仅选择国家是不够的。',
  locationSaveFailed: '无法使用该位置。请重试或选择其他位置。',
}

export default constants
